import { useEffect, useCallback } from 'react';
import { useHourlySync, useOnlineStatus } from 'utils/serviceWorkerUtils';
import { MasterSync } from 'MasterSync';

const SyncManager = ({ intervalMinutes = 60 }) => { // Changed to 60 minutes (1 hour) for production
  const isOnline = useOnlineStatus();
  
  const syncFunction = useCallback(() => {
    const subconId = sessionStorage.getItem("subcon_id");
    if (subconId && isOnline) {
      console.log('Running MasterSync...', new Date().toLocaleTimeString());
      MasterSync(subconId);
    } else {
      console.log('Skipping sync - offline or no subcon_id');
    }
  }, [isOnline]);

  const { isActive, startSync, stopSync } = useHourlySync(
    syncFunction, 
    intervalMinutes
  );

  // Auto-start sync when component mounts and user is online
  useEffect(() => {
    if (isOnline && !isActive) {
      startSync();
    }
  }, [isOnline, isActive, startSync]);

  // Stop sync when offline
  useEffect(() => {
    if (!isOnline && isActive) {
      stopSync();
    }
  }, [isOnline, isActive, stopSync]);

  // Don't render anything visible - this is just a background service
  return null;
};

export default SyncManager;
